import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  Col,
  Container,
  Form,
  FormInput,
  FormTextarea,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  ListGroup,
  ListGroupItem,
  Row,
} from "shards-react";
import { strings } from "../../localization";
import PageTitle from "../../components/common/PageTitle";
import { ToastContainer, toast } from "react-toastify";
import { Link } from "react-router-dom";
import Select from "react-select";
import { API_URL } from "../../config";

const customStyles = {
  control: (provided) => ({
    ...provided,
    marginBottom: "15px",
    fontSize: "14px",
  }),
};

function ManageCategory(props) {
  const { id } = props.match.params;

  // states
  const [categoryName, setCategoryName] = useState("");
  const [items, setItems] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [loader, setLoader] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  // This function is used to handle save button click event
  const handleSaveButtonClick = () => {
    if (!categoryName) {
      showToasMessage(strings.fill_fields, false);
    } else {
      const itemsId = [];
      if (selectedItems.length > 0) {
        selectedItems.map((item) => itemsId.push(item.value));
      }
      const bodyData = JSON.stringify({
        name: categoryName,
        itemIDs: itemsId,
      });
      console.log("bodyData for create or edit category", bodyData);

      const categoryId = id ? `/${id}` : "";
      let statusCode = 0;
      fetch(`${API_URL}web-food-category${categoryId}`, {
        method: categoryId ? "put" : "post",
        credentials: "include",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: bodyData,
      })
        .then((res) => {
          statusCode = res.status;
          return res.json();
        })
        .then((res) => {
          console.log("category post api response", res);
          const message = res["message"]
            ? res["message"]
            : "Something went wrong!";
          setIsButtonDisabled(false);
          if (statusCode === 200) {
            showToasMessage(strings.successfully_created, true);

            // setTimeout(() => {
            //   history.goBack();
            // }, 1000);
          } else {
            showToasMessage(message, false);
          }
        })
        .catch((err) => {
          console.warn(err);
          setIsButtonDisabled(false);
          showToasMessage("Something went wrong!", false);
        });
    }
  };

  // This function is used to display toast message
  const showToasMessage = (message, isSuccess) => {
    if (isSuccess) {
      toast.success(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  // This function is used to handle table click event
  const handleItemSelection = (e) => {
    console.log("event", e);
    const selectedValue = e;
    if (selectedValue) {
      setSelectedItems([...selectedValue]);
    } else {
      setSelectedItems([]);
    }
  };

  // This function is used to call item get api
  const getItemsList = () => {
    let statusCode = 0;
    fetch(`${API_URL}items`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        statusCode = res.status;
        return res.json();
      })
      .then((res) => {
        console.log("item get api response", res);
        const data = res["result"];
        console.log("data of items get api", data);
        if (statusCode === 200) {
          if (data) {
            const itemData = [];
            data &&
              data.length > 0 &&
              data.map((item) => {
                itemData.push({
                  label: item.data.name,
                  value: item._id,
                });
              });
            console.log("itemData", itemData);
            setItems([...itemData]);
          }
          if (id) {
            getCategoryDetail();
          }
        } else {
          showToasMessage("Something went wrong!", false);
        }
      })
      .catch((err) => {
        console.log("item get api catch block error", err);
        showToasMessage("Something went wrong!", false);
      });
  };

  // This function is used to call category detail get api
  const getCategoryDetail = () => {
    let statusCode = 0;
    fetch(`${API_URL}web-food-category/${id}`, {
        method: "GET",
        credentials: "include"
    })
        .then(res => {
            statusCode = res.status;
            return res.json();
        })
        .then((res) => {
            console.log('category detail api response', res);
            const data = res;
            if (statusCode === 200) {
                if (data) {
                    const itemList = data['items'];
                    const itemData = [];
                    setCategoryName(data['name']);
                    itemList && itemList.length > 0 && itemList.map((item) => {
                        itemData.push({
                            label: item.name,
                            value: item._id
                        })
                    })
                    console.log('itemData', itemData);
                    setSelectedItems([...itemData]);
                }
            } else {
                showToasMessage("Something went wrong!", false);
            }
        }).catch((err) => {
            console.log('restaurant category detail get api catch block error', err);
            showToasMessage("Something went wrong!", false);
        })
  };

  useEffect(() => {
    getItemsList();
  }, []);

  return (
    <Container
      fluid
      className="main-content-container px-4"
      style={{ marginBottom: "200px" }}
    >
      <Row noGutters className="page-header py-4">
        <PageTitle
          title={id ? strings.edit_category : strings.create_category}
          md="12"
          className="ml-sm-auto mr-sm-auto"
        />
      </Row>
      <Row>
        <Col lg="6" md="10" sm="12">
          <Card small className="mb-4">
            <CardHeader className="border-bottom">
              <h6 className="m-0">
                {id ? strings.edit_category : strings.create_category}
              </h6>
            </CardHeader>
            <ListGroup flush>
              <ListGroupItem className="p-3">
                <Row>
                  <Col>
                    <Form id="TableForm">
                      <label htmlFor="name">{strings.category_name}</label>
                      <InputGroup seamless className="mb-3">
                        <FormInput
                          type="text"
                          id="name"
                          value={categoryName}
                          placeholder={strings.category_name}
                          onChange={(e) => setCategoryName(e.target.value)}
                        />
                      </InputGroup>
                      <Select
                        options={items}
                        onChange={handleItemSelection}
                        placeholder={strings.select_items}
                        value={selectedItems}
                        isMulti
                        styles={customStyles}
                      />
                      <ToastContainer />
                      <Button
                        theme="accent"
                        onClick={handleSaveButtonClick}
                        disabled={isButtonDisabled}
                      >
                        <i className={loader} style={{ fontSize: "15px" }}></i>{" "}
                        {strings.save}
                      </Button>
                    </Form>
                  </Col>
                </Row>
              </ListGroupItem>
            </ListGroup>
          </Card>
        </Col>
        <Col>
          <Link to={"/categories"} className="float-left">
            <Button
              id="go_back"
              theme="light"
              className="mb-2 mr-1"
              style={{
                marginTop: "-84px",
                position: "relative",
                left: "-100px",
              }}
            >
              {strings.go_back}
            </Button>
          </Link>
        </Col>
      </Row>
    </Container>
  );
}

export default ManageCategory;
